import React from "react";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import {PopupMenu} from "@hapinest/theme";
import {useResortsMenu} from "../../../hooks";
import { Box } from "@material-ui/core";
import useOrientation from "../../../hooks/useOrientation";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(1.5)
    },
    countryIcon: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        display: "flex"
    }
}));

const HeaderResortsMenu = ({ anchorEl, onCloseMenu }) => {
    const classes = useStyles();
    const {angle} = useOrientation();
    const {menuItems} = useResortsMenu(classes.countryIcon, angle === 90);

    return (
        <>
            <PopupMenu
                className={classes.root}
                anchorEl={anchorEl}
                menuItems={menuItems}
                onClose={onCloseMenu}
                subMenuOpenMode={angle === 90 ? "click" : "hover"}
            />

            {/* Always render hyperlinks to DOM for SEO purposes  */}
            <Box display={"none"}>
                {menuItems?.map((item, index) => (
                    <Box key={index}>
                        <a
                            key={index}
                            href={item.href}
                        >{item.text}</a>

                        {menuItems[index]?.subItems?.map((subItem, index2) => (
                            <a
                                key={index2}
                                href={subItem.href}
                            >{subItem.text}</a>
                        ))}
                    </Box>
                ))}
            </Box>
        </>
    );
};

HeaderResortsMenu.propTypes = {
    anchorEl: PropTypes.any,
    onCloseMenu: PropTypes.func.isRequired
};

export default HeaderResortsMenu;
